export default "__VITE_ASSET__01hqciix__"